import { Box } from '@mui/material'
import { Drawer, Loader } from 'packages/eid-ui'
import ItemHeader from '../ItemHeader'
import { isNilOrEmpty, useIsSmallScreen } from 'packages/core'
import {
    useApplication,
    useCheckApplicationsAccess,
    useTargetPerson,
} from 'hooks'
import ItemsDetailsMobileWrapper from 'components/ItemsDetailsMobileWrapper'
import ApplicationDetails from './ApplicationDetails'
import { useEffect, useState } from 'react'
import { useResourceTypeContext } from 'resourceTypeContext'
import { catalogDetailsDrawerExplainProps } from '../catalogDetailsDrawerExplain'

const ApplicationsDrawer = ({
    id,
    toggleDrawer,
    item,
    currentResourceType,
}) => {
    const [accessLevel, setAccessLevelValue] = useState(null)
    const [accessLevels, setAccessLevels] = useState([])
    const isSmallScreen = useIsSmallScreen()
    const [targetPerson] = useTargetPerson()
    const [{ referencePerson }, dispatch] = useResourceTypeContext()
    const { data } = useApplication(id)

    const handleAccessLevelChange = (val) => {
        setAccessLevelValue(val)
        dispatch({
            type: 'UPDATE_SELECTED_ACCESS_LEVEL_ALREADY_ASSIGNED',
            payload: {
                selectedAppRoleOrRightAlreadyAssigned: false,
                accessType: '',
            },
        })
        dispatch({
            type: 'UPDATE_SELECTED_ACCESS_LEVEL_APP_ROLE_OR_RIGHT',
            payload: val?.resourceAssignment?.id,
        })
    }

    const { data: accessLevelsData, isInitialLoading: isCheckingAccess } =
        useCheckApplicationsAccess(id, referencePerson?.id, data)

    useEffect(() => {
        if (accessLevel && accessLevels && accessLevels.length === 1) {
            setAccessLevelValue(accessLevels[0])
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [accessLevels, setAccessLevelValue])

    useEffect(() => {
        if (accessLevelsData) {
            const tempLevels = [
                ...(accessLevelsData?.managementRoles || []),
                ...(accessLevelsData?.localRights || []),
                ...(accessLevelsData?.azureRoles || []),
            ]
            if (tempLevels?.length) {
                // Converting to resourceAssignment key to keep the exiting components working
                const levels = tempLevels.map((item) => {
                    return {
                        resourceAssignment: {
                            ...item,
                        },
                    }
                })
                setAccessLevels(levels)
            }
        } else {
            setAccessLevels([])
        }
        setAccessLevelValue(null)
        dispatch({
            type: 'UPDATE_SELECTED_ACCESS_LEVEL_ALREADY_ASSIGNED',
            payload: {
                selectedAppRoleOrRightAlreadyAssigned: false,
                accessType: '',
            },
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [accessLevelsData])

    return isSmallScreen ? (
        <ItemsDetailsMobileWrapper toggleDrawer={toggleDrawer}>
            <Box {...catalogDetailsDrawerExplainProps('application')}>
                <ItemHeader title={data?.friendlyName} />
                {!data && <Loader />}
                {data && (
                    <ApplicationDetails
                        application={data}
                        accessLevel={accessLevel}
                        accessLevels={accessLevels}
                        setAccessLevelValue={(val) => handleAccessLevelChange(val)}
                        isCheckingAccess={isCheckingAccess}
                        targetPerson={targetPerson}
                        applicationId={id}
                        item={item}
                        currentResourceType={currentResourceType}
                    />
                )}
            </Box>
        </ItemsDetailsMobileWrapper>
    ) : (
        <Drawer
            width="clamp(67%, 1007px, 90%)"
            open={!isNilOrEmpty(id)}
            toggleDrawer={toggleDrawer}
            stickyHeader
            closeOnOutsideClick
            header={<ItemHeader title={data?.friendlyName} />}
        >
            <Box {...catalogDetailsDrawerExplainProps('application')}>
                {!data && <Loader />}
                {data && (
                    <ApplicationDetails
                        application={data}
                        accessLevel={accessLevel}
                        accessLevels={accessLevels}
                        setAccessLevelValue={(val) =>
                            handleAccessLevelChange(val)
                        }
                        isCheckingAccess={isCheckingAccess}
                        targetPerson={targetPerson}
                        applicationId={id}
                        item={item}
                        currentResourceType={currentResourceType}
                    />
                )}
            </Box>
        </Drawer>
    )
}

export default ApplicationsDrawer
